exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".navHeader-module-iconStyle{padding-right:2px}.navHeader-module-backRow{line-height:46px;font-weight:bold;font-size:13px;letter-spacing:.04em;text-transform:uppercase;padding-left:16px}.navHeader-module-backRow i{line-height:46px}.navHeader-module-backRow span{padding-left:12px}", ""]);

// Exports
exports.locals = {
	"iconStyle": "navHeader-module-iconStyle",
	"backRow": "navHeader-module-backRow"
};